import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { sendAlert } from '../../../actions/utils';

import ComplaintForm from './ComplaintForm';
import { createComplaintRequest } from '../../../requests/complaints';
import basicComplaint from './complaint';
import { LinkBtn, Icon } from '../../../components';

const ComplaintNewProfile = () => {
  const dispatch = useDispatch();
  const [moreData, setMoreData] = useState(false);
  const history = useHistory();

  const handleSuccessCreate = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
  };

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleCreate = complaint => {
    createComplaintRequest({
      dispatch,
      params: snakeCaseKeys(complaint),
      successCallback: () => {
        handleSuccessCreate('Denuncia creada con éxito');
        history.push('/profile/complaints');
      },
      failureCallback: handleFailureRequest
    });
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col xs={1}>
          <LinkBtn variant="circle-dark" className="btn-circle" block to="/profile/complaints">
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>
        <Col>
          <h2 className="text-uppercase mb-0">Nueva Denuncia</h2>
        </Col>
      </Row>
      <Row className="main-div pb-3">
        <Col>
          <ComplaintForm action="new" complaint={basicComplaint} formRequest={handleCreate} />
        </Col>
      </Row>
    </>
  );
};

export default ComplaintNewProfile;
